var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column",staticStyle:{"height":"100vh"},attrs:{"id":"app"}},[(!_vm.isAuthorizationPage)?_c('TopBar'):_vm._e(),_c('div',{staticClass:"flex-grow-1"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }